import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatientForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';

type Props = {
  baseInfo: IncidentDetailPatientForSendai['baseInfo'];
};

export const BaseInfoView = ({ baseInfo }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="基本情報" />

        {/* 傷病者住所 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="傷病者住所"
            content={baseInfo.patientAddress ?? ''}
          />
        </div>

        {/* 氏名・ふりがな・職業 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="氏名" content={baseInfo.name} />
          <InfoDisplay title="フリガナ" content={baseInfo.furigana ?? ''} />
          <InfoDisplay title="傷病者職業" content={baseInfo.occupation ?? ''} />
        </div>

        {/* 年齢・生年月日・性別 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="年齢"
            content={baseInfo.age ? `${baseInfo.age}歳` : ''}
          />
          <InfoDisplay title="生年月日" content={baseInfo.birthday ?? ''} />
          <InfoDisplay title="性別" content={baseInfo.sex ?? ''} />
        </div>

        {/* 保健福祉センター扱(生活保護) */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="保健福祉センター扱(生活保護)区別"
            content={baseInfo.welfareData?.welfareDistrict ?? ''}
          />
          <InfoDisplay
            title="保健福祉センター扱(生活保護)区別 その他"
            content={baseInfo.welfareData?.welfareDistrictOther ?? ''}
          />
        </div>

        {/* 救急コール有無 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="救急コール" content={baseInfo.hasCall ?? ''} />
        </div>
      </div>
    </BorderedContainer>
  );
};
